"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isDate = function isDate(obj) {
  return obj instanceof Date;
};

var _default = isDate;
exports["default"] = _default;